module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "base-input"
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, _vm._l((_vm.imgList), function(item, index) {
    return _c('el-col', {
      key: index,
      staticClass: "base-item",
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "base-item-list"
    }, [_c('img', {
      ref: ("imgRef" + index),
      refInFor: true,
      staticStyle: {
        "width": "220px",
        "height": "72px"
      },
      attrs: {
        "src": item.imgSrc,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.bgChange(index)
        }
      }
    }), _vm._v(" "), (index == _vm.itemIndex) ? _c('label', {
      staticClass: "el-upload-list__item-status-label"
    }, [_c('i', {
      staticClass: "el-icon-upload-success el-icon-check"
    })]) : _vm._e()])])
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7514d2ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/components/createBackground.vue
// module id = 714
// module chunks = 1